import { getWorkOrderAttachments } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import { get } from "lodash-es";

type Props = {
	WorkOrderId: number | null;
	setAttachmentsList: Function;
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchWorkOrderAttachments = ({
	WorkOrderId,
	setAttachmentsList,
	setIsLoading,
	setError,
}: Props) => {
	return async () => {
		setIsLoading(true);
		const res = await getWorkOrderAttachments(WorkOrderId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setAttachmentsList(rowsSource);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setError(res.message);
		}
	};
};
